const locale = {
	TITLE: "Strategy",
};

export default locale;
